import { createFileRoute } from "@tanstack/react-router";
import { ImportacaoDetalhePage } from "@/pages/ImportacaoDetalhePage";

export const Route = createFileRoute("/importacoes/$id")({
  head: () => ({ meta: [{ title: "Importação — AXIS Comprovantes" }] }),
  component: ImportacaoDetalhePage,
});
